import useStepper from "../../../components/stepper/hooks/useStepper";
import SvgIcon from "../../../components/svgIcon";
import { DESIGN_CATEGORY } from "../../../constants/designs";
import { SHUFFLE_ICON_URL } from "../../../constants/iconsUrls";
import Shape from "../../../models/furniture/Shape";
import Material from "../../../models/furniture/Material";

function OptionsShuffle({
  options,
  selectShape,
  selectMaterial,
}: {
  options: (Shape | Material)[];
  isLoadingOptions?: boolean;
  selectShape: (selectedShape: Shape, elementOrder: number) => void;
  selectMaterial: (
    selectedMaterial: Material,
    elementOrder: number,
    materialOrder: number
  ) => void;
}) {
  const { currentStepData } = useStepper();

  const isShape = currentStepData?.category === DESIGN_CATEGORY.SHAPE;
  const isMaterial = currentStepData?.category === DESIGN_CATEGORY.MATERIAL;

  const handleShuffling = () => {
    if (!options || options.length === 0) {
      return;
    }

    const randomIdx = Math.floor(Math.random() * options.length);

    if (isShape) {
      selectShape(
        options[randomIdx] as Shape,
        currentStepData?.elementOrder as number
      );
    } else if (isMaterial) {
      selectMaterial(
        options[randomIdx] as Material,
        currentStepData?.elementOrder as number,
        currentStepData?.materialOrder as number
      );
    }
  };

  return (
    <SvgIcon
      src={SHUFFLE_ICON_URL}
      onClick={handleShuffling}
      className="h-[20px] w-[20px] cursor-pointer text-secondary hover:text-primary"
    />
  );
}

export default OptionsShuffle;
